import React from "react";

interface LiveIndicatorProps {
    isLoading: boolean;
    onRefresh: () => void;
}

const LiveIndicator: React.FC<LiveIndicatorProps> = ({ isLoading, onRefresh }) => {
    return (
        <div className="flex items-center gap-2">
            <div className="flex items-center gap-1.5 px-2.5 py-1.5 bg-[#1a1a1a] border border-[#2d2d2d] rounded">
                <span
                    className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${isLoading ? "bg-yellow-500" : "bg-green-500"}`}
                />
                <span className="text-xs text-gray-400 hidden sm:inline">{isLoading ? "Updating" : "Live"}</span>
            </div>

            <button
                onClick={onRefresh}
                disabled={isLoading}
                title="Refresh"
                className="flex items-center justify-center w-7 h-7 bg-[#1a1a1a] border border-[#2d2d2d] rounded text-gray-400 hover:text-gray-200 hover:bg-[#222222] disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
                <svg
                    className={`w-3.5 h-3.5 ${isLoading ? "animate-spin" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    />
                </svg>
            </button>
        </div>
    );
};

export default LiveIndicator;
